var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61248 7.29268C1.31952 6.94586 1.31952 6.43793 1.61248 6.09111C2.40641 5.15186 4.17163 3.44189 6.50002 3.44189C8.82841 3.44189 10.5936 5.15186 11.3876 6.09111C11.6805 6.43793 11.6805 6.94586 11.3876 7.29268C10.5936 8.23193 8.82841 9.94189 6.50002 9.94189C4.17163 9.94189 2.40641 8.23193 1.61248 7.29268Z",
    stroke: "#673C8E",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50002 8.08475C7.78211 8.08475 8.82145 7.04541 8.82145 5.76332C8.82145 4.48123 7.78211 3.44189 6.50002 3.44189C5.21793 3.44189 4.17859 4.48123 4.17859 5.76332C4.17859 7.04541 5.21793 8.08475 6.50002 8.08475Z",
    stroke: "#673C8E",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.2ccb39bb3e817b76727e4fbc3b3e16f3.svg";
export { ForwardRef as ReactComponent };